module.exports = __webpack_public_path__ + "img/loginBack.fe6c04dc.png";